import { render, staticRenderFns } from "./PriceUnitSetting.vue?vue&type=template&id=2c9b0451&scoped=true&"
import script from "./PriceUnitSetting.vue?vue&type=script&lang=js&"
export * from "./PriceUnitSetting.vue?vue&type=script&lang=js&"
import style0 from "./PriceUnitSetting.vue?vue&type=style&index=0&id=2c9b0451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b0451",
  null
  
)

export default component.exports